import axiosGraphQL from './GraphQL/axiosGraphQL';
import { GroupRoleQuerys } from './GraphQL/Queries/GroupRoleQuerys';
import {
  GroupRoleVariables,
  IGetComboboxGroup,
  IGetComboboxJobTitle,
  IGetComboboxJobTitleNew,
  IGetGroupRole,
  IUpdateGroupRoleManagement,
  IUpdateGroupRoleManagementStatus,
} from './GraphQL/Variables/GroupRoleVariables';

export const GroupRoleApis = {
  getGroupRole: async (params: IGetGroupRole): Promise<any> => {
    return await axiosGraphQL.post('/graphql', {
      query: GroupRoleQuerys.GET_GROUP_ROLE,
      variables: GroupRoleVariables.getGroupRole(params),
    });
  },
  saveGroupRole: async (params: any): Promise<any> => {
    return await axiosGraphQL.post('/graphql', {
      query: GroupRoleQuerys.SAVE_GROUP_ROLE,
      variables: GroupRoleVariables.saveGroupRole(params),
    });
  },
  getCbxUnitLevel: async (params: any): Promise<any> => {
    return await axiosGraphQL.post('/graphql', {
      query: GroupRoleQuerys.GET_CBX_UNIT_LEVEL,
      variables: GroupRoleVariables.getCbxUnitLevel(params),
    });
  },
  getCbxPosition: async (params: any): Promise<any> => {
    return await axiosGraphQL.post('/graphql', {
      query: GroupRoleQuerys.GET_CBX_POSITION,
      variables: GroupRoleVariables.getCbxPosition(params),
    });
  },
  getCbxStaus: async (params: any): Promise<any> => {
    return await axiosGraphQL.post('/graphql', {
      query: GroupRoleQuerys.GET_CBX_STATUS,
      variables: GroupRoleVariables.getCbxStaus(params),
    });
  },
  getCbxObject: async (params: any): Promise<any> => {
    return await axiosGraphQL.post('/graphql', {
      query: GroupRoleQuerys.GET_CBX_OBJECT,
      variables: GroupRoleVariables.getCbxObject(params),
    });
  },
  getCbxGroup: async (params: any): Promise<any> => {
    return await axiosGraphQL.post('/graphql', {
      query: GroupRoleQuerys.GET_CBX_GROUP,
      variables: GroupRoleVariables.getCbxGroup(params),
    });
  },
  //   Get combobox Group
  getComboboxGroup: async (params: IGetComboboxGroup): Promise<any> => {
    return await axiosGraphQL.post('/graphql', {
      query: GroupRoleQuerys.GET_COMBOBOX_GROUP_ROLE_MANAGEMENT,
      variables: GroupRoleVariables.getComboboxGroup(params),
    });
  },
  // Get combobox Job title
  getComboboxJobTitle: async (params: IGetComboboxJobTitle): Promise<any> => {
    return await axiosGraphQL.post('/graphql', {
      query: GroupRoleQuerys.GET_COMBOBOX_JOB_TITLE,
      variables: GroupRoleVariables.getComboboxJobTitle(params),
    });
  },
  // Get combobox Job title new
  getComboboxJobTitleNew: async (
    params: IGetComboboxJobTitleNew,
  ): Promise<any> => {
    return await axiosGraphQL.post('/graphql', {
      query: GroupRoleQuerys.GET_COMBOBOX_JOB_TITLE_NEW,
      variables: GroupRoleVariables.getComboboxJobTitleNew(params),
    });
  },
  // Update Group Role Management on/off
  updateGroupRoleManagementStatus: async (
    params: IUpdateGroupRoleManagementStatus,
  ): Promise<any> => {
    return await axiosGraphQL.post('/graphql', {
      query: GroupRoleQuerys.UPDATE_GROUP_ROLE_MANAGEMENT_STATUS,
      variables: GroupRoleVariables.updateGroupRoleManagementStatus(params),
    });
  },
  // Update Group Role Management
  updateGroupRoleManagement: async (
    params: IUpdateGroupRoleManagement,
  ): Promise<any> => {
    return await axiosGraphQL.post('/graphql', {
      query: GroupRoleQuerys.UPDATE_GROUP_ROLE_MANAGEMENT,
      variables: GroupRoleVariables.updateGroupRoleManagement(params),
    });
  },
};
